/**
 * Application constants
 *
 * This file contains all constants used throughout the application.
 * Centralizing them here makes it easier to maintain and update values.
 */

// Default values
export const DEFAULTS = {
  INITIAL_LAP_NUMBER: 0,
  FIRST_LAP_NUMBER: 1,
} as const;

// Time formatting constants
export const TIME_FORMAT = {
  MINUTES_IN_MS: 60000,
  SECONDS_IN_MS: 1000,
  PAD_LENGTH: 2,
  MS_PAD_LENGTH: 3,
} as const;

// Segment distances in meters
export const SEGMENT_DISTANCES = {
  SHORT: 100,
  MEDIUM: 200,
  LONG: 400,
} as const;
